module.exports = __webpack_public_path__ + "img/ZJ5140.68e0ee5b.png";